module.exports = __webpack_public_path__ + "static/media/09.63910934.jpg";